let thumbnailPosition = 0;

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-modal.media-modal, product-modal.product-media-modal');
  if (!modal) return;

  const contentSel = '.product-media-modal__content';

  let swiperInstance = null;

  // --- Utility: wait until Swiper is available, then run callback
  const whenSwiperReady = (cb) => {
    if (window.Swiper) return cb();
    const start = performance.now();
    const t = setInterval(() => {
      if (window.Swiper) {
        console.log('[modal-swiper] Swiper is ready');
        clearInterval(t);
        cb();
      } else if (performance.now() - start > 10000) {
        clearInterval(t);
        console.warn('[modal-swiper] Swiper not found within 10s.');
      }
    }, 50);
  };

  // --- Build Swiper structure by MOVING existing media nodes (not cloning)
  const buildSwiperFromContent = () => {
    const content = modal.querySelector(contentSel);
    if (!content) return;

    // Collect original media nodes in order (img, video, deferred-media)
    const mediaNodes = Array.from(content.children).filter((n) =>
      ['IMG', 'VIDEO', 'DEFERRED-MEDIA'].includes(n.tagName)
    );
    if (!mediaNodes.length) return;

    // Create Swiper container + wrapper + controls
    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper product-media-swiper';

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    // Wrap each media node in a slide and MOVE it in
    mediaNodes.forEach((node) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      if (node.tagName === 'VIDEO' && !node.hasAttribute('controls')) {
        node.setAttribute('controls', 'controls');
      }
      slide.appendChild(node); // MOVE
      wrapper.appendChild(slide);
    });

    // Controls
    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'swiper-button-next';
    nextBtn.setAttribute('aria-label', 'Next slide');
    nextBtn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>';

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'swiper-button-prev';
    prevBtn.setAttribute('aria-label', 'Previous slide');
    prevBtn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41 10.83 12l4.58 4.59L14 18l-6-6 6-6 1.41 1.41z"/></svg>';

    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';

    swiperContainer.appendChild(wrapper);
    swiperContainer.appendChild(nextBtn);
    swiperContainer.appendChild(prevBtn);
    swiperContainer.appendChild(pagination);

    // Replace modal content with Swiper container
    content.innerHTML = '';
    content.appendChild(swiperContainer);

    // Inject minimal arrow styles
    ensureSwiperModalStyles();

    // Init Swiper
    whenSwiperReady(() => {
      if (swiperInstance) return;

      swiperInstance = new Swiper('.product-media-swiper', {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 1,
        centeredSlides: false,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });

      // Video handling: pause inactive, play active
      const pauseAllVideos = () => {
        wrapper.querySelectorAll('video').forEach((v) => {
          try {
            v.pause();
          } catch (_) {}
        });
      };
      const playActiveVideo = () => {
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (!activeSlide) return;
        const v = activeSlide.querySelector('video');
        if (v) {
          if (!v.hasAttribute('muted')) v.muted = true;
          v.play().catch(() => {});
        }
      };

      swiperInstance.on('init', () => {
        pauseAllVideos();
        playActiveVideo();
      });
      swiperInstance.on('slideChangeTransitionStart', pauseAllVideos);
      swiperInstance.on('slideChangeTransitionEnd', playActiveVideo);
    });
  };

  const ensureSwiperModalStyles = () => {
    if (document.getElementById('swiper-modal-inline-css')) return;
    const style = document.createElement('style');
    style.id = 'swiper-modal-inline-css';
    style.textContent = `
      .product-media-modal .product-media-swiper { position: relative; }
      .product-media-modal .swiper-button-next,
      .product-media-modal .swiper-button-prev {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 44px;
        height: 44px;
        border: 0;
        border-radius: 9999px;
        background: rgba(0,0,0,0);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;
        color: #413e3e;
      }
      .product-media-modal .swiper-button-next { right: 8px; }
      .product-media-modal .swiper-button-prev { left: 8px; }
      .product-media-modal .swiper-button-next svg,
      .product-media-modal .swiper-button-prev svg {
        width: 20px; height: 20px; fill: rgba(0,0,0,0);
      }
      .product-media-modal .swiper-pagination {
        position: absolute; left: 0; right: 0; bottom: 8px;
        z-index: 10;
      }
    `;
    document.head.appendChild(style);
  };

  // Watch modal open/close — only build Swiper when opened first time
  const observer = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        if (modal.hasAttribute('open')) {
          if (!swiperInstance) {
            buildSwiperFromContent();
          } else {
            swiperInstance.slideTo(thumbnailPosition, 0);
          }
        }
      }
    }
  });
  observer.observe(modal, { attributes: true });

  if (modal.hasAttribute('open')) {
    if (!swiperInstance) {
      buildSwiperFromContent();
    } else {
      swiperInstance.slideTo(0, 0); // reset to first slide instantly
    }
  }

  const thumbnails = document.querySelectorAll('.thumbnail-list.slider li button');

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      thumbnailPosition = index; // Store clicked thumbnail position
      console.log(`Thumbnail clicked: ${thumbnailPosition}`);
    });
  });
});
